import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { currencyToSign } from '../../../../utils/utils';

const renderConfig = [126, 202, 203, 205, 204];

const renderCommonFields = (stat, fields, currencyPostfix, fieldConfig) => {
  return renderConfig.map((item, rowKey) => {
    const index = fields.findIndex(field => field.id === item);
    const fieldData = fieldConfig.find(field => field.id === item);
    if (fieldData && !fieldData.isRendering) return null;
    switch (item) {
      case 205:
        // console.log(stat[index]);
        return <td key={`conversion-table-row-cell-${index}-${rowKey}`}>{stat[index]}</td>;
      case 204:
        const statusFieldsConfig = fieldConfig.filter(
          field => field.id === 2040 || field.id === 2041,
        );
        return stat[index]
          ? stat[index].map((item, key) => {
              if (statusFieldsConfig[key] && !statusFieldsConfig[key].isRendering) return null;
              return <td key={`conversion-table-row-geo-${index}-${key}`}>{item}</td>;
            })
          : null;
      case 126:
        return (
          <td key={`conversion-table-row-cell-${index}-${rowKey}`}>
            <span>
              {stat[index]} <strong>{currencyPostfix}</strong>
            </span>
          </td>
        );
      default:
        return <td key={`conversion-table-row-cell-${index}-${rowKey}`}>{stat[index]}</td>;
    }
  });
};

const renderCommentField = (info, fieldConfig) => {
  const commentField = fieldConfig.find(field => field.id === 2051);
  if (commentField && !commentField.isRendering) return null;

  return <td>{info.comment}</td>;
};

const getStatus = info => {
  if (!Object.keys(info).length) {
    return 'empty';
  }

  return info.isTrash ? 'trash' : info.status.id;
};

const StatisticsConversionsRow = ({
  commonFields,
  info,
  subacc,
  config,
  currency,
  currencies,
  fieldConfig,
}) => {
  const isMoreInfo = () => info.phone || subacc;
  const [isAdditionalInfoOpen, setAdditionalInfoOpenState] = useState(false);
  const toggleAdditionalInfo = e => {
    e.preventDefault();
    const state = !isAdditionalInfoOpen;
    setAdditionalInfoOpenState(state);
  };
  const currencyPostfix = currencyToSign(currencies[currency]);
  return (
    <Fragment>
      <tr className={`status-${getStatus(info)}`}>
        {renderCommonFields(commonFields, config, currencyPostfix, fieldConfig)}
        {renderCommentField(info, fieldConfig)}
        <td>
          {isMoreInfo() && (
            <a href="#" onClick={toggleAdditionalInfo}>
              {isAdditionalInfoOpen ? (
                <FormattedMessage
                  id="statistics.table.conversions.actions.hide"
                  defaultMessage="Hide"
                />
              ) : (
                <FormattedMessage
                  id="statistics.table.conversions.actions.show_more"
                  defaultMessage="More info"
                />
              )}
            </a>
          )}
        </td>
      </tr>

      {isMoreInfo() && isAdditionalInfoOpen && (
        <tr className="conversions-table-additional">
          <td colSpan="2">
            <span className="conversions-table-additional-container">
              <span className="conversions-table-additional-item">
                {info.phone && (
                  <FormattedMessage
                    id="statistics.table.conversions.phone"
                    defaultMessage="Phone"
                  />
                )}
              </span>{' '}
              <span className="conversions-table-additional-item">{info.phone}</span>
            </span>
          </td>
          <td>{subacc}</td>
        </tr>
      )}
    </Fragment>
  );
};

export default StatisticsConversionsRow;
